import { deleteMakersAction, fetchMakersAction } from "./actions";
import { push } from "connected-react-router";
import { FirebaseTimestamp, db } from "../../firebase";
import {
  collection,
  doc,
  getDocs,
  deleteDoc,
  orderBy,
  updateDoc,
  addDoc,
  setDoc,
  writeBatch,
  query,
  documentId,
  where,
  Timestamp,
  getDoc,
} from "firebase/firestore";

const makerssRef = collection(db, "makers");

export const saveMakers = (newMakers) => {
  return async (dispatch) => {
    const makers = await fetchMakersWithNoRedux();
    const timestamp = FirebaseTimestamp.now();
    const batch = [];

    // 1. makersに存在し、newMakersに存在しないカテゴリを削除
    makers.forEach((maker) => {
      const makerExistsInNew = newMakers.some(
        (newMaker) => newMaker.id === maker.id
      );
      if (!makerExistsInNew) {
        //存在しなかったら
        const docRef = doc(db, "makers", maker.id);
        batch.push(deleteDoc(docRef));
      }
    });

    // 2. newMakersに存在し、makersに存在しないカテゴリを追加
    newMakers.forEach((newMaker) => {
      const makerExistsInMakers = makers.some(
        (maker) => maker.id === newMaker.id
      );
      if (!makerExistsInMakers) {
        //存在しなかったら
        const data = {
          id: "",
          mid: newMaker.mid,
          name: newMaker.name,
          updated_at: timestamp,
          created_at: timestamp,
        };
        batch.push(addNewDocument(data));
      }
    });

    // 3. makersとnewMakersの両方に存在するカテゴリを更新
    newMakers.forEach((newMaker) => {
      const makerExistsInMakers = makers.some(
        (maker) => maker.id === newMaker.id
      );
      if (makerExistsInMakers) {
        const makerToUpdate = makers.find((maker) => maker.id === newMaker.id);
        if (JSON.stringify(makerToUpdate) !== JSON.stringify(newMaker)) {
          const docRef = doc(db, "makers", newMaker.id);
          const data = {
            id: newMaker.id,
            mid: newMaker.mid,
            name: newMaker.name,
            updated_at: timestamp,
          };
          batch.push(updateDoc(docRef, data, { merge: true }));
        }
      }
    });

    try {
      await Promise.all(batch);
      dispatch(push("/"));
    } catch (error) {
      console.error("Error synchronizing makers: ", error);
      throw new Error(error);
    }
  };
};

const addNewDocument = async (newData) => {
  const collectionRef = collection(db, "makers");

  try {
    const docRef = await addDoc(collectionRef, newData);
    const newDocumentId = docRef.id;
    const newDataWithId = { ...newData, id: newDocumentId };
    const docRefToUpdate = doc(db, "makers", newDocumentId);
    await updateDoc(docRefToUpdate, newDataWithId);
  } catch (error) {
    console.error("Error adding document: ", error);
  }
};

export const fetchMakers = () => {
  return async (dispatch) => {
    const q = query(collection(db, "makers"), orderBy("mid", "asc"));
    const querySnapshot = await getDocs(q);
    const list = [];
    querySnapshot.forEach((doc) => {
      const data = doc.data();
      list.push({
        id: data.id,
        mid: data.mid,
        name: data.name,
      });
    });
    //console.trace("list:",list);
    dispatch(fetchMakersAction(list));
  };
};

const fetchMakersWithNoRedux = async () => {
  const q = query(collection(db, "makers"), orderBy("id", "asc"));
  const querySnapshot = await getDocs(q);
  const list = [];
  querySnapshot.forEach((doc) => {
    const data = doc.data();
    list.push({
      id: doc.id,
      mid: data.mid,
      name: data.name,
    });
  });
  return list;
};
